import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';

const initialState = Immutable({
  error: false,
  updating: false,
  prettyId: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.METAMORPH_LOGIN_CREATE_COMPANY.START: {
      return state.merge({
        updating: true,
      });
    }
    case actionTypes.METAMORPH_LOGIN_CREATE_COMPANY.SUCCESS: {
      const { prettyId } = action.payload;
      return state.merge({
        prettyId: prettyId,
        updating: false,
      });
    }
    case actionTypes.METAMORPH_LOGIN_CREATE_COMPANY.FAILURE: {
      const { error } = action.payload;

      return state.merge({
        updating: false,
        error,
      });
    }

    default:
      return state;
  }
}
